// Agent transfers the person sent or was sent: seeded on workspace open, kept live by
// cybo_transfer_request_changed, so the Alerts card and the sender's pill survive a reload.
import type { CyboTransferRequestView } from "$lib/core/client.js";
import { accountSync } from "$lib/plugins/agents/sync-session.js";

export class CyboTransferRequestsState {
  requests: CyboTransferRequestView[] = $state([]);

  load(requests: CyboTransferRequestView[]): void {
    this.requests = requests;
  }

  upsert(request: CyboTransferRequestView): void {
    const idx = this.requests.findIndex((r) => r.id === request.id);
    if (idx === -1) {
      this.requests = [...this.requests, request];
      return;
    }
    const next = this.requests.slice();
    next[idx] = request;
    this.requests = next;
  }

  byId(id: string): CyboTransferRequestView | undefined {
    return this.requests.find((r) => r.id === id);
  }

  pendingForCybo(cyboId: string): CyboTransferRequestView | undefined {
    return this.requests.find((r) => r.cyboId === cyboId && r.status === "pending");
  }

  clear(): void {
    this.requests = [];
  }
}

export const cyboTransferRequestsState = new CyboTransferRequestsState();
accountSync.adopt("cyboTransferRequests", cyboTransferRequestsState, (s) => s.clear());
